import { UsersIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const EntityAccessEmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex h-40 flex-col items-center justify-center gap-3 rounded-md border border-background-darker bg-white text-center">
      <UsersIcon className="size-8 text-text-secondary/40" aria-hidden="true" />
      <p className="text-sm font-semibold leading-6 text-text-secondary">
        {t('select-user-to-manage-entity-access')}
      </p>
    </div>
  );
};
